<template>
    <div>
        <div v-for="server in serverList">
            <a :href="$laroute.route('reports_show', { server_id: server.entity_id })" title="View Reports">
                {{ server.entity_name }} / {{ server.server_name}} ( {{ server.server_ip }} )
            </a>
        </div>
    </div>
</template>
<script>
import dateParse from "date-fns/parse";
import distanceInWordsToNow from "date-fns/distance_in_words_to_now";

export default {
    props: {
        serverList: Array
    },
    methods: {
        elapsedTime: function(time) {
            return distanceInWordsToNow(dateParse(time * 1000), {
                includeSeconds: true,
                addSuffix: true
            });
        }
    }
};
</script>
